import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

declare const bootstrap: any;

@Directive({
    selector: '[data-bs-toggle="tooltip"]'
})
export class BootstrapTooltip implements OnInit, OnDestroy {
    private tooltip: any;

    constructor(private el: ElementRef) {}

    ngOnInit(): void {
        this.tooltip = new bootstrap.Tooltip(this.el.nativeElement);
    }

    ngOnDestroy(): void {
        this.tooltip?.dispose();
    }
}
